import React, { useState, useEffect } from 'react';
import Home from './Home.jsx';
import { store } from '@betacrew/jars-flux'
import { Provider } from 'react-redux';
import "@fontsource/lato";
import ToastPortal from './businesslogic/toaster/ToasterPortal.js';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Config from "./config.web.js";

const globalStyles = {
    fontFamily: 'Lato',
    height: '100%',
}

function App() {
    return (<>
        <Provider store={store}>
            <GoogleOAuthProvider clientId={Config.GOOGLE_LOGIN_CLIENT_ID}>
                <div id='mainContainer' style={globalStyles}>
                    <Home />
                    <ToastPortal />
                </div>
            </GoogleOAuthProvider>
        </Provider>
    </>)

}



export default App;